// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"3f6bee47","239":"0d3de44f","338":"c338dd70","453":"8c88dd9f","732":"c29b8000","749":"0cb446b8","861":"c4d9d120"}[chunkId] + ".chunk.js";
};